exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs-menu{margin-top:3.1rem !important;border-bottom:2px solid #dee2e6;border-bottom-width:2px !important;border-bottom-style:solid !important;border-bottom-color:#dee2e6 !important;z-index:1028 !important}.tabs-menu .active{color:#234dd0 !important;border-bottom:5px solid #234dd0;border-bottom-width:5px !important;border-bottom-style:solid !important}.tabs-menu a:hover{text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/common/layout/tabs.scss
// module id = 3999
// module chunks = 0